import { useEffect } from "react";
import axios from "axios";
import { useQueryClient } from "react-query";
import { API_ENDPOINT } from "../constants/constants";
import { getHeader } from "../utility/utility";

// Mark the list read only after it has loaded, then refresh the shared badge.
const useMarkNotificationsSeen = (isSuccess) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!isSuccess) return;

    axios.get(`${API_ENDPOINT}/user/seen-my-notifications`, getHeader())
      .then(() => queryClient.invalidateQueries([
        `${API_ENDPOINT}/user/my-notifications-unseen-count`,
      ]))
      .catch((error) => {
        console.error("Failed to mark notifications as read", error);
      });
  }, [isSuccess, queryClient]);
};

export default useMarkNotificationsSeen;
